import "./svg/nav-cart-quantity-filled.svg"

export default {
    name: "nav-cart-quantity-filled",
    viewBox: "25 25",
}
